export const normalizeText = (text: string): string => {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
};

export const highlightSearchTerm = (text: string, searchTerm: string): string => {
  if (!searchTerm || searchTerm.length < 3) return text;
  
  const normalizedText = normalizeText(text);
  const normalizedSearch = normalizeText(searchTerm);
  
  if (!normalizedText.includes(normalizedSearch)) return text;
  
  const startIndex = normalizedText.indexOf(normalizedSearch);
  const endIndex = startIndex + normalizedSearch.length;
  
  return (
    text.substring(0, startIndex) +
    `<mark class="bg-yellow-200">${text.substring(startIndex, endIndex)}</mark>` +
    text.substring(endIndex)
  );
};